import { render } from "./viewAcceptRejectDetails.vue?vue&type=template&id=6b9196a2"
import script from "./viewAcceptRejectDetails.vue?vue&type=script&lang=js"
export * from "./viewAcceptRejectDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__